export const getLStorage = (key) => localStorage.getItem(key);
export const setLStorage = (key, value) => localStorage.setItem(key, value);